import onlineHelper from "@/services/onlineStations";
import { getSocket } from "@/main_app";

let freeSearchSocket = null;

export default {
  data() {
    return {
      pgInterval: null,
      freeSearchErrors: [
        this.$t("freeSearchErrors.error1"),
        this.$t("freeSearchErrors.error1"),
        this.$t("freeSearchErrors.error2"),
        this.$t("freeSearchErrors.error3"),
        this.$t("freeSearchErrors.error4"),
        this.$t("freeSearchErrors.error5"),
        this.$t("freeSearchErrors.error6"),
        this.$t("freeSearchErrors.error7"),
      ],
    };
  },

  methods: {
    doFreeSearch(
      search,
      booksToSearch = [],
      historyId = 0,
      book = false,
      tabId = null,
      historyMainId = 0
    ) {
      //reset online timer on each freesearch
      onlineHelper.startOnlineTimer();

      this.$store.state.tabsManager.scrollToFsResult = true;
      if (Array.isArray(booksToSearch))
        booksToSearch = [...new Set(booksToSearch)];
      if (search == "") return;
      return new Promise((resolve, reject) => {
        if (!this.freeSearchBookListStore) {
          console.log(
            `Error: Cannot do freesearch without a freesearchbooklist store`
          );
          reject();
          return;
        }

        this.freeSearchBookListStore.setFirstTimeSearch(true);

        let booksBuffer = null;
        let searchType = this.$store.state.freeSearch.searchType;
        //tsiyunim and maftechot search
        if (searchType == "special") {
          this.freeSearchBookListStore.setCurrentFSListName("");

          this.$store.dispatch("freeSearch/setSearchProgress", 0);
          let currProg = 0;
          this.pgInterval = setInterval(() => {
            currProg += 10;

            this.$store.dispatch("freeSearch/setSearchProgress", currProg);
          }, 1);
          this.$store.dispatch("freeSearch/setSearching", true);

          this.$store.dispatch(
            "freeSearchBooklistComp/checkAllListBooksFree",
            false
          );

          this.freeSearchBookListStore.showFreeSearchList();

          this.freeSearchBookListStore.setSearchTxt(search);
        } else {
          //classic search
          //create buffer of books to send to search server and to save in history
          let pos = 0;

          if (!Array.isArray(booksToSearch)) booksBuffer = booksToSearch;
          else {
            booksBuffer = Buffer.alloc(booksToSearch.length * 12);
            booksToSearch.forEach((book) => {
              booksBuffer.writeInt32LE(book, pos);
              pos += 12;
            });
          }
          if (!book) {
            //close advanced popup
            this.freeSearchBookListStore.setCurrentFSListName("");

            this.$store.dispatch("freeSearch/setShowAdvPopup", false);
            this.$store.dispatch("freeSearch/setSearchProgress", 0);
            let currProg = 0;
            this.pgInterval = setInterval(() => {
              currProg += 10;

              this.$store.dispatch("freeSearch/setSearchProgress", currProg);
            }, 1);

            this.$store.dispatch("freeSearch/setSearchString", search);
            this.$store.dispatch("freeSearch/setSearching", true);

            this.freeSearchBookListStore.setSearchTxt(search);
            this.$store.dispatch(
              "freeSearchBooklistComp/checkAllListBooksFree",
              false
            );

            this.freeSearchBookListStore.showFreeSearchList();

            search = this.$store.getters["freeSearch/getSearchWordsForSearch"];
          } else
            search = this.$store.getters["freeSearch/getSearchWords1"](search);
        }

        //do free search
        if (freeSearchSocket == null) {
          freeSearchSocket = getSocket();
          //listenFinishedFreeSearch(freeSearchSocket, book, tabId, searchType);
        }
        freeSearchSocket.emit("freesearch", {
          txt: JSON.stringify(search), //this.searchText,
          books: booksBuffer,
          historyId,
          searchType,
          book,
          tabId,
          userId: this.$store.getters["user/getUserId"],
          historyMainId,
          searchId: this.freeSearchBookListStore.id,
        });
      });
    },
    async getBooksToSearchIn() {
      let listType = "";
      let booksToSearch = [];
      let searchInType = this.freeSearchBookListStore.searchInType;

      let searchEnum = this.$store.state.freeSearch.enumSearchInType;
      if (searchInType >= searchEnum.custom) {
        booksToSearch = this.freeSearchBookListStore.searchInBooks;
        listType = "custom";
      } else {
        switch (searchInType) {
          case searchEnum.all:
            booksToSearch = [];
            this.freeSearchBookListStore.setBooksToSearchIn(booksToSearch);
            break;

          case searchEnum.selected:
            let checkedBooks1 = this.$store.getters["bookList/getCheckedBooks"];
            let checkedBooks2 = this.freeSearchBookListStore.getCheckedBooks;
            booksToSearch = Array.from(
              new Set(checkedBooks1.concat(checkedBooks2))
            );
            this.freeSearchBookListStore.setBooksToSearchIn(booksToSearch);
            listType = "selected";
            break;

          case searchEnum.inMeforesh:
            //get books of current list
            let catId =
              this.$store.getters["bookList/getDataOfCurrentList"].data.id ||
              this.$store.getters["bookList/getDataOfCurrentList"].data.listId;

            booksToSearch = { meforesh: true, id: catId };
            this.freeSearchBookListStore.setBooksToSearchIn(booksToSearch);
            listType = "mef";
            break;

          case searchEnum.browse:
            booksToSearch = this.freeSearchBookListStore.searchInBooks;
            booksToSearch.sort((a, b) => a - b);
            listType = "browse";
            break;

          case searchEnum.currentList:
            booksToSearch = await this.$store.dispatch(
              "bookList/getBooksIdCurrentList",
              null
            );
            booksToSearch.sort((a, b) => a - b);
            this.freeSearchBookListStore.setBooksToSearchIn(booksToSearch);
            listType = "currentList";
            break;
          case searchEnum.tsiyunim:
            listType = "special";
            booksToSearch = [];
            break;

          default:
            booksToSearch = this.freeSearchBookListStore.searchInBooks;
            if (!booksToSearch) {
              booksToSearch = [];
              this.freeSearchBookListStore.setBooksToSearchIn(booksToSearch);
            }
        }
      }
      this.freeSearchBookListStore.currentSearchInType = listType;

      if (Array.isArray(booksToSearch)) booksToSearch.sort((a, b) => a - b);
      return booksToSearch;
    },
    //clear free search input
    clear() {
      this.$store.dispatch("freeSearch/setSearchString", "");
      this.freeSearchBookListStore.setTextInput("");
    },
  },
};
